import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Table } from "antd";
import TextField from "@mui/material/TextField";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { DatePicker, Switch } from "antd";
import moment from "moment";

const MitwankPromoCode = () => {
  const navigate = useNavigate();
  const [promoCodeData, setPromoCodeData] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
    showSizeChanger: true,
  });
  function getPromoCode() {
    var Url =
      window.API_PREFIX +
      "admin/offercouponlist";
    fetch(Url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "Block") {
          toast.error(data["message"]);
          localStorage.clear();
          navigate("/Clinic");
          window.location.reload();
        }
        if (data["status"]) {
          const promoCodeData = [...data["offerCouponList"]];
          const dataWithSrNo = promoCodeData.map((item, index) => ({
            ...item,
            srNo: index + 1,
          }));
          setPromoCodeData(dataWithSrNo);
        }
      });
  }

  useEffect(() => {
    getPromoCode();
  }, []);
  const promoCodeColumn = [
    {
      title: "Sr No",
      dataIndex: "srNo",
      render(text, record, index) {
        return {
          props: {
            style: { fontSize: "16px", textAlign: "center", color: "#483a15" },
          },
          children: <div style={{ fontWeight: "600" }}>{record.srNo}</div>,
        };
      },
    },
    {
      title: "Clinic",
      dataIndex: "clinicDetails",
      key: "clinicDetails",
      render: (text, record) => <div>{record.clinicDetails?.clinicName}</div>,
    },
    {
      title: "Coupon Code",
      dataIndex: "couponCode",
      key: "couponCode",
      render: (text, record) => <div>{record.couponCode}</div>,
    },
    {
      title: "Coupon For",
      dataIndex: "couponFor",
      key: "couponFor",
      render: (text, record) => <div>{record.couponFor}</div>,
    },
    {
      title: "Discount Type",
      dataIndex: "discountType",
      key: "discountType",
      render: (text, record) => <div>{record.discountType}</div>,
    },
    {
      title: "Discount Value",
      dataIndex: "discountValue",
      key: "discountValue",
      render: (text, record) => (
        <div>
          {record.discountType === "Fixed Amount"
            ? record.fixDiscountAmount
            : record.discountValue}
        </div>
      ),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (text, record) => <div>{record.startDate}</div>,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (text, record) => <div>{record.endDate}</div>,
    },
    {
      title: "Usage Limit",
      dataIndex: "usageLimit",
      key: "usageLimit",
      render: (text, record) => <div>{record.usageLimit}</div>,
    },
    {
      title: "Used Count",
      dataIndex: "usedCount",
      key: "usedCount",
      render: (text, record) => <div>{record.usedCount}</div>,
    },
    {
      title: "Status",
      dataIndex: "activationStatus",
      key: "activationStatus",
      render: (text, record) => (
        <div
          style={{
            backgroundColor:
              record.activationStatus === "Active" ? "green" : "red",
            color: "white",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          {record.activationStatus}
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "Actions",
      key: "Actions",
      render: (text, record, index) => (
        <div className="d-flex justify-content-center align-items-center">
          <i
            class="fa-solid fa-pen me-2"
            style={{ color: "green" }}
            onClick={() => {
              setSelectedRow(record);
              setEditModal(true);
            }}
          ></i>
          <i
            class="fa-solid fa-trash-can me-2"
            style={{ color: "#e11f28" }}
            onClick={() => {
              delete_promoCode(record?.id);
            }}
          ></i>
        </div>
      ),
    },
  ];

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleOutsideClick = (event) => {
    if (event.target.id === "myModal") {
      setAddModal(false);
    }
  };
  const handleOutsideClickEditModal = (event) => {
    if (event.target.id === "myModal") {
      setEditModal(false);
    }
  };

  const onSubmit = () => {
    setAddModal(false);
    setEditModal(false);
    getPromoCode();
  };

  const delete_promoCode = (id) => {
    var Url = window.API_PREFIX + "admin/deleteoffercoupon";

    let formData = new FormData();
    formData.append("id", id);

    fetch(Url, {
      method: "POST",
      headers: {},
      body: formData,
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "Block") {
          toast.error(data["message"]);
          localStorage.clear();
          navigate("/Clinic");
          window.location.reload();
        }
        if (data["status"]) {
          getPromoCode();
        }
      });
  };
  return (
    <div>
      <div className="container-fuild mx-2">
        <div class="text-end mt-2">
          <button
            class="mitwank_patient_profile_add_prescription_btn"
            onClick={() => {
              setAddModal(true);
            }}
          >
            + Add Promo Code
          </button>
        </div>
        <div className="mitwank_patient_profile_table_division">
          <Table
            columns={promoCodeColumn}
            pagination={pagination}
            dataSource={promoCodeData}
            onChange={handleTableChange}
          />
        </div>
      </div>

      {addModal && (
        <AddPromoCodeModal
          setAddModal={setAddModal}
          handleOutsideClick={handleOutsideClick}
          onSubmit={onSubmit}
        />
      )}
      {editModal && (
        <EditPromoCodeModal
          selectedRow={selectedRow}
          setEditModal={setEditModal}
          handleOutsideClickEditModal={handleOutsideClickEditModal}
          onSubmit={onSubmit}
        />
      )}
    </div>
  );
};

export default MitwankPromoCode;

const AddPromoCodeModal = ({ setAddModal, handleOutsideClick, onSubmit }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [allClinic, setAllClinic] = useState([]);
  const [inputData, setInputData] = useState({
    clinicId: "",
    discountType: "",
    couponFor: "",
    couponCode: "",
    startDate: "",
    endDate: "",
    usageLimit: "",
    activationStatus: true,
    minPurchaseAmount: "",
    discountValue: "",
    usageLimitforSingleUser: "",
  });

  useEffect(() => {
    const Url = window.API_PREFIX + "admin/allclinics";
    fetch(Url, {
      method: "GET",
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "1") {
          setAllClinic([...data["allClinicList"]]);
        }
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputData?.couponFor) {
      toast.error("Please select coupon for");
    } else if (!inputData?.clinicId) {
      toast.error("Please select clinic");
    } else if (!inputData?.couponCode) {
      toast.error("Please enter coupon code");
    } else if (!inputData?.discountType) {
      toast.error("Please select discount type");
    } else if (!inputData?.discountValue) {
      toast.error("Please enter discount value");
    } else if (!inputData?.minPurchaseAmount) {
      toast.error("Please enter min purchase amount");
    } else if (!inputData?.startDate) {
      toast.error("Please select start date");
    } else if (!inputData?.endDate) {
      toast.error("Please select end date");
    } else if (!inputData?.usageLimit) {
      toast.error("Please enter usage limit");
    } else if (!inputData?.usageLimitforSingleUser) {
      toast.error("Please enter usage limit for single user");
    } else {
      setLoading(true);
      let formData = new FormData();
      formData.append("couponFor", inputData?.couponFor);
      formData.append("couponCode", inputData?.couponCode);
      formData.append("discountType", inputData?.discountType);
      if (inputData?.discountType === "Percentage") {
        formData.append("discountValue", inputData?.discountValue);
      } else {
        formData.append("fixDiscountAmount", inputData?.discountValue);
      }
      formData.append("minPurchaseAmount", inputData?.minPurchaseAmount);

      if (inputData?.startDate) {
        formData.append(
          "startDate",
          inputData?.startDate?.format("YYYY-MM-DD")
        );
      }

      if (inputData?.endDate) {
        formData.append("endDate", inputData?.endDate?.format("YYYY-MM-DD"));
      }

      formData.append("usageLimit", inputData?.usageLimit);
      formData.append(
        "usageLimitforSingleUser",
        inputData?.usageLimitforSingleUser
      );
      formData.append(
        "activationStatus",
        inputData?.activationStatus ? "Active" : "InActive"
      );
      formData.append("clinicId", inputData?.clinicId);
      formData.append("created_by", localStorage.getItem("LoginDetails"));
      fetch(window.API_PREFIX + "admin/addoffercoupon", {
        method: "POST",
        body: formData,
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data?.status === "Block") {
            toast.error(data?.message);
            localStorage.clear();
            navigate("/Clinic");
            window.location.reload();
          } else if (data?.status) {
            toast.success(data?.message);
            setLoading(false);
            setInputData({
              discountType: "",
              couponFor: "",
              couponCode: "",
              startDate: "",
              endDate: "",
              usageLimit: "",
              activationStatus: true,
              minPurchaseAmount: "",
              discountValue: "",
              usageLimitforSingleUser: "",
            });
            onSubmit();
          }
        });
    }

    console.log(inputData);
  };
  return (
    <div id="myModal" className="modal" onClick={handleOutsideClick}>
      <div className="modal-content">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Add Promo Code</h5>
          <i
            onClick={() => {
              setAddModal(false);
            }}
            class="fa-solid fa-xmark fa-x close"
          ></i>
        </div>
        <div className="mt-3">
          <div
            className="client_register_personal_gender_main_division"
            style={{ height: "40px" }}
          >
            <button
              className={
                inputData.couponFor === "Event"
                  ? "client_register_personal_male_btn_active"
                  : "client_register_personal_male_btn"
              }
              onClick={() => {
                setInputData({ ...inputData, couponFor: "Event" });
              }}
            >
              <i class="fa-solid fa-calendar-days me-2"></i> Event
            </button>
            <button
              className={
                inputData.couponFor === "Appointment"
                  ? "client_register_personal_female_btn_active"
                  : "client_register_personal_female_btn"
              }
              onClick={() => {
                setInputData({ ...inputData, couponFor: "Appointment" });
              }}
            >
              <i class="fa-solid fa-calendar-days me-2"></i> Appointment
            </button>
          </div>

          <div className="client_register_personal_gender_main_division">
            <FormControl fullWidth className="mt-2">
              <InputLabel id="demo-simple-select-label">Clinic</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inputData.clinicId}
                label="Clinic"
                onChange={(e) =>
                  setInputData({ ...inputData, clinicId: e.target.value })
                }
              >
                {allClinic.map((branch) => (
                  <MenuItem key={branch.id} value={branch.id}>
                    {branch.clinicName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              label="Coupon Code"
              value={inputData.couponCode}
              onChange={(e) =>
                setInputData({
                  ...inputData,
                  couponCode: e.target.value.toUpperCase(),
                })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Discount Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inputData.discountType}
                label="Discount Type"
                onChange={(e) =>
                  setInputData({ ...inputData, discountType: e.target.value })
                }
              >
                <MenuItem value={"Percentage"}>Percentage</MenuItem>
                <MenuItem value={"Fixed Amount"}>Fixed Amount</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              type="number"
              label="Discount Value"
              value={inputData.discountValue}
              onChange={(e) =>
                setInputData({ ...inputData, discountValue: e.target.value })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              label="Min Purchase Amount"
              value={inputData.minPurchaseAmount}
              onChange={(e) =>
                setInputData({
                  ...inputData,
                  minPurchaseAmount: e.target.value,
                })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <DatePicker
              placeholder="Start Date"
              style={{ width: "100%" }}
              value={inputData.startDate}
              onChange={(newValue) =>
                setInputData({ ...inputData, startDate: newValue })
              }
              format="DD-MM-YYYY"
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <DatePicker
              placeholder="End Date"
              style={{ width: "100%" }}
              value={inputData.endDate}
              format="DD-MM-YYYY"
              onChange={(newValue) =>
                setInputData({ ...inputData, endDate: newValue })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              label="Usage Limit"
              type="number"
              value={inputData.usageLimit}
              onChange={(e) =>
                setInputData({ ...inputData, usageLimit: e.target.value })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              label="Usage Limit for Single User"
              type="number"
              value={inputData.usageLimitforSingleUser}
              onChange={(e) =>
                setInputData({
                  ...inputData,
                  usageLimitforSingleUser: e.target.value,
                })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <span>Activation Status</span>
            <Switch
              checked={inputData.activationStatus}
              onChange={(checked) =>
                setInputData({ ...inputData, activationStatus: checked })
              }
            />
          </div>

          <div class="d-flex justify-content-center mt-3">
            <button
              type="button"
              class="popup_submit_button btn"
              disabled={loading}
              onClick={(e) => {
                handleSubmit(e);
              }}
            >
              Add Promo Code
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const EditPromoCodeModal = ({
  selectedRow,
  setEditModal,
  handleOutsideClickEditModal,
  onSubmit,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [allClinic, setAllClinic] = useState([]);
  const [inputData, setInputData] = useState({
    clinicId: selectedRow?.clinicDetails?.id,  
    discountType: selectedRow?.discountType,
    couponFor: selectedRow?.couponFor,
    couponCode: selectedRow?.couponCode,
    startDate: selectedRow?.startDate ? moment(selectedRow?.startDate) : null,
    endDate: selectedRow?.endDate ? moment(selectedRow?.endDate) : null,
    usageLimit: selectedRow?.usageLimit,
    activationStatus: selectedRow?.activationStatus === "Active" ? true : false,
    minPurchaseAmount: selectedRow?.minPurchaseAmount,
    discountValue:
      selectedRow?.discountType === "Percentage"
        ? selectedRow?.discountValue
        : selectedRow?.fixDiscountAmount,
    usageLimitforSingleUser: selectedRow?.usageLimitforSingleUser,
  });

  useEffect(() => {
    const Url = window.API_PREFIX + "admin/allclinics";
    fetch(Url, {
      method: "GET",
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "1") {
          setAllClinic([...data["allClinicList"]]);
        }
      });
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputData?.couponFor) {
      toast.error("Please select coupon for");
    } else if (!inputData?.clinicId) {
      toast.error("Please select clinic");
    } else if (!inputData?.couponCode) {
      toast.error("Please enter coupon code");
    } else if (!inputData?.discountType) {
      toast.error("Please select discount type");
    } else if (!inputData?.discountValue) {
      toast.error("Please enter discount value");
    } else if (!inputData?.minPurchaseAmount) {
      toast.error("Please enter min purchase amount");
    } else if (!inputData?.startDate) {
      toast.error("Please select start date");
    } else if (!inputData?.endDate) {
      toast.error("Please select end date");
    } else if (!inputData?.usageLimit) {
      toast.error("Please enter usage limit");
    } else if (!inputData?.usageLimitforSingleUser) {
      toast.error("Please enter usage limit for single user");
    } else {
      setLoading(true);
      let formData = new FormData();
      formData.append("id", selectedRow?.id);
      formData.append("couponFor", inputData?.couponFor);
      formData.append("couponCode", inputData?.couponCode);
      formData.append("discountType", inputData?.discountType);
      if (inputData?.discountType === "Percentage") {
        formData.append("discountValue", inputData?.discountValue);
      } else {
        formData.append("fixDiscountAmount", inputData?.discountValue);
      }
      formData.append("minPurchaseAmount", inputData?.minPurchaseAmount);

      if (inputData?.startDate) {
        formData.append(
          "startDate",
          inputData?.startDate?.format("YYYY-MM-DD")
        );
      }

      if (inputData?.endDate) {
        formData.append("endDate", inputData?.endDate?.format("YYYY-MM-DD"));
      }

      formData.append("usageLimit", inputData?.usageLimit);
      formData.append(
        "usageLimitforSingleUser",
        inputData?.usageLimitforSingleUser
      );
      formData.append(
        "activationStatus",
        inputData?.activationStatus ? "Active" : "InActive"
      );
      formData.append("clinicId", inputData?.clinicId);
      formData.append("updated_by", localStorage.getItem("LoginDetails"));
      fetch(window.API_PREFIX + "admin/editoffercoupon", {
        method: "POST",
        body: formData,
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data?.status === "Block") {
            toast.error(data?.message);
            localStorage.clear();
            navigate("/Clinic");
            window.location.reload();
          } else if (data?.status) {
            toast.success(data?.message);
            setLoading(false);
            setInputData({
              clinicId: "",
              discountType: "",
              couponFor: "",
              couponCode: "",
              startDate: "",
              endDate: "",
              usageLimit: "",
              activationStatus: true,
              minPurchaseAmount: "",
              discountValue: "",
              usageLimitforSingleUser: "",
            });
            onSubmit();
          }
        });
    }

    console.log(inputData);
  };
  return (
    <div id="myModal" className="modal" onClick={handleOutsideClickEditModal}>
      <div className="modal-content">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Update Promo Code</h5>
          <i
            onClick={() => {
              setEditModal(false);
            }}
            class="fa-solid fa-xmark fa-x close"
          ></i>
        </div>
        <div className="mt-3">
          <div
            className="client_register_personal_gender_main_division"
            style={{ height: "40px" }}
          >
            <button
              className={
                inputData.couponFor === "Event"
                  ? "client_register_personal_male_btn_active"
                  : "client_register_personal_male_btn"
              }
              onClick={() => {
                setInputData({ ...inputData, couponFor: "Event" });
              }}
            >
              <i class="fa-solid fa-calendar-days me-2"></i> Event
            </button>
            <button
              className={
                inputData.couponFor === "Appointment"
                  ? "client_register_personal_female_btn_active"
                  : "client_register_personal_female_btn"
              }
              onClick={() => {
                setInputData({ ...inputData, couponFor: "Appointment" });
              }}
            >
              <i class="fa-solid fa-calendar-days me-2"></i> Appointment
            </button>
          </div>
          <div className="client_register_personal_gender_main_division">
            <FormControl fullWidth className="mt-2">
              <InputLabel id="demo-simple-select-label">Clinic</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inputData.clinicId}
                label="Clinic"
                onChange={(e) =>
                  setInputData({ ...inputData, clinicId: e.target.value })
                }
              >
                {allClinic.map((branch) => (
                  <MenuItem key={branch.id} value={branch.id}>
                    {branch.clinicName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              label="Coupon Code"
              value={inputData.couponCode}
              onChange={(e) =>
                setInputData({
                  ...inputData,
                  couponCode: e.target.value.toUpperCase(),
                })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Discount Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inputData.discountType}
                label="Discount Type"
                onChange={(e) =>
                  setInputData({ ...inputData, discountType: e.target.value })
                }
              >
                <MenuItem value={"Percentage"}>Percentage</MenuItem>
                <MenuItem value={"Fixed Amount"}>Fixed Amount</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              type="number"
              label="Discount Value"
              value={inputData.discountValue}
              onChange={(e) =>
                setInputData({ ...inputData, discountValue: e.target.value })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              label="Min Purchase Amount"
              value={inputData.minPurchaseAmount}
              onChange={(e) =>
                setInputData({
                  ...inputData,
                  minPurchaseAmount: e.target.value,
                })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <DatePicker
              placeholder="Start Date"
              style={{ width: "100%" }}
              value={inputData.startDate}
              onChange={(newValue) =>
                setInputData({ ...inputData, startDate: newValue })
              }
              format="DD-MM-YYYY"
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <DatePicker
              placeholder="End Date"
              style={{ width: "100%" }}
              value={inputData.endDate}
              format="DD-MM-YYYY"
              onChange={(newValue) =>
                setInputData({ ...inputData, endDate: newValue })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              label="Usage Limit"
              type="number"
              value={inputData.usageLimit}
              onChange={(e) =>
                setInputData({ ...inputData, usageLimit: e.target.value })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <TextField
              fullWidth
              label="Usage Limit for Single User"
              type="number"
              value={inputData.usageLimitforSingleUser}
              onChange={(e) =>
                setInputData({
                  ...inputData,
                  usageLimitforSingleUser: e.target.value,
                })
              }
            />
          </div>

          <div className="client_register_personal_gender_main_division">
            <span>Activation Status</span>
            <Switch
              checked={inputData.activationStatus}
              onChange={(checked) =>
                setInputData({ ...inputData, activationStatus: checked })
              }
            />
          </div>

          <div class="d-flex justify-content-center mt-3">
            <button
              type="button"
              class="popup_submit_button btn"
              disabled={loading}
              onClick={(e) => {
                handleSubmit(e);
              }}
            >
              Update Promo Code
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
